import "./styles.scss";

import React from "react";
import clsx from "clsx";

import SimpleCard from "components/SimpleCard";
import CardSlider from "components/CardSlider";

import { getColorVariant } from "utils";

const Offer = ({ list }) => {
  const isEmpty = !list?.length > 0;

  return (
    <section className={clsx("main-offer", isEmpty && "main-offer--empty")}>
      {!isEmpty && (
        <>
          <div className="container d-none d-sm-block">
            <div className="row">
              {list.map((item, index) => (
                <div key={index} className="col-lg-4 col-sm-6">
                  <SimpleCard
                    url={item.content.link}
                    image={item.image?.sourceUrl}
                    title={item.content.title}
                    description={item.content.description}
                    variant={getColorVariant(index + 1)}
                    isEqual
                  />
                </div>
              ))}
            </div>
          </div>
          <CardSlider breakpoint="sm">
            {list.map((item, index) => (
              <div key={index} className="main-offer__slider-item">
                <SimpleCard
                  url={item.content.link}
                  image={item.image?.sourceUrl}
                  title={item.content.title}
                  description={item.content.description}
                  variant={getColorVariant(index + 1)}
                  isEqual
                />
              </div>
            ))}
          </CardSlider>
        </>
      )}
    </section>
  );
};

export default Offer;
